import controller from './organization-billing.controller';

const template = require('./organization-billing.html');

export default {
    controller,
    template
};
